<template>
  <b-modal
    visible
    no-close-on-esc
    ok-only
    no-close-on-backdrop
    no-enforce-focus
    :title="`Lịch sử chăm sóc bệnh nhân: ${benhNhan.name} - Mã XN: ${benhNhan.testCode}`"
    size="xl"
    @ok="handleOk()"
    @hidden="handleHidden()"
  >
    <b-container fluid>
      <b-tabs v-model="tabIndex" content-class="mt-3">
        <b-tab title="Tất cả sự kiện">
          <benh-nhan-history-list-event :benhNhan="benhNhan" />
        </b-tab>
        <b-tab title="Chăm sóc" active>
          <div v-if="listLoading" class="text-center text-primary">
            <b-spinner></b-spinner>
          </div>
          <div v-if="!listLoading && !itemCount" class="text-center text-danger">
            {{ $t('emptyList') }}
          </div>
          <div v-if="!listLoading && itemCount" class="c-template-table table-responsive">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Gọi lúc</th>
                  <th>Nhóm NC</th>
                  <th>Ghi chú</th>
                  <th>Hẹn gọi tiếp</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items" :key="item._id">
                  <td>{{ items.length - index }}</td>
                  <td>
                    <p>
                      <b>Thời gian: </b>
                      {{ item.time | moment('DD/MM/YY HH:mm') }}
                    </p>
                    <p>
                      <b v-if="$store.state.roles.find(r => r.key === item.user.role)">{{
                        $store.state.roles.find(r => r.key === item.user.role).name
                      }}</b>
                      {{ item.user ? item.user.name : 'Chưa rõ' }}
                    </p>
                  </td>
                  <td class="text-center">
                    <span v-if="!item.tier" class="badge badge-secondary">Chưa cập nhật</span>
                    <span v-else-if="item.tier === 'nc0'" class="badge badge-success">NC0</span>
                    <span v-else-if="item.tier === 'nc1'" class="badge badge-info">NC1</span>
                    <span v-else-if="item.tier === 'nc2'" class="badge badge-primary">NC2</span>
                    <span v-else-if="item.tier === 'nc3'" class="badge badge-warning">NC3</span>
                    <span v-else class="badge badge-danger">NC4</span>
                  </td>
                  <td>
                    {{ item.note ? item.note : 'Không có ghi chú' }}
                  </td>
                  <td>
                    <span v-if="item.nextCallTime">{{ item.nextCallTime | moment('DD/MM/YY HH:mm') }}</span>
                    <span v-else>Không cập nhật</span>
                  </td>
                  <td>
                    <benh-nhan-detail v-if="item.type == null || item.type == 'care'" :benh-nhan="benhNhan" :history="item" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
            <b-pagination
              size="sm"
              class="pagination pagination-sm justify-content-center"
              v-model="filterFormModel.page"
              :total-rows="itemCount"
              :per-page="filterFormModel.pageSize"
              @input="load"
            >
            </b-pagination>
          </div>
        </b-tab>
        <b-tab title="Lịch sử gọi">
          <benh-nhan-history-list-call :benhNhan="benhNhan" />
        </b-tab>
      </b-tabs>
    </b-container>
  </b-modal>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import BenhNhanHistoryListCall from './BenhNhanHistoryListCall.vue';
import BenhNhanHistoryListEvent from './BenhNhanHistoryListEvent.vue';
import BenhNhanDetail from './BenhNhanDetail.vue';

export default {
  components: {BenhNhanHistoryListCall, BenhNhanDetail, BenhNhanHistoryListEvent},
  inheritAttrs: false,
  props: {
    benhNhan: {
      type: Object,
      required: true,
      validator: benhNhan => !!benhNhan._id,
    },
  },
  mixins: [list, crud],
  data() {
    return {
      tabIndex: 0,
      service: '/benh-nhan-call?type=care',
      autoLoad: true,
      reloadBus: 'reloadBenhNhanCall',
      defaultFilterFormModel: {
        benhNhan: this.benhNhan._id,
      },
      defaultFormModel: {
        callTime: null,
        tier: null,
        user: null,
        note: null,
      },
    };
  },
  computed: {},
  methods: {
    handleOk() {
      this.$emit('hidden');
    },
    handleHidden() {
      this.$emit('hidden');
    },
  },
};
</script>
